import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';

export const Paragraph = styled.p`
  margin-top: ${({ theme }) => theme.spacing.one};

  color: ${({ theme }) => theme.colors.black_40};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-family: ${({ theme }) => theme.fontFamily.medium};
  letter-spacing: ${({ theme }) => theme.letterSpacing.md};
  text-align: center;
`;

export const TermsAndConditions = styled(Link)`
  color: ${({ theme }) => theme.colors.black_100};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
`;

export const Account = styled.p`
  margin-top: ${({ theme }) => theme.spacing.three_2};

  color: ${({ theme }) => theme.colors.black_100};
  font-size: ${({ theme }) => theme.fontSize.xxs};
`;

export const SignUpLink = styled(Link)`
  margin-top: ${({ theme }) => theme.spacing.one};

  color: ${({ theme }) => theme.colors.negative_default};
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
`;

export const SuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  height: calc(100vh - 6rem);
  padding: ${({ theme }) => `0 ${theme.spacing.one_2}`};

  text-align: center;
`;

export const ButtonSpacing = styled.div`
  margin-top: ${({ theme }) => theme.spacing.two_2};
`;
